import { H3 } from '@h3/types';
import { request } from '@h3/request';

export const getExportColumns = (params: H3.Export.Request.IExportColumnModel) =>
    request<H3.Http.Response.H3ResponseV2<H3.Export.Response.GetExportColumnsResponse>>('/ExcelExport/OnAction', {
        method: 'post',
        params,
    });

// 获取导入模板
export const getImportTemplateUrl = (
    schemaCode: string,
    fields: Array<{ PropertyName: string; DisplayName: string; Required: boolean }>,
) => {
    const url = '/v/dataexport/GetImportTemplateUrl';
    return request<H3.Http.Response.H3Response<string>>(url, {
        method: 'post',
        data: {
            SchemaCode: schemaCode,
            Fields: fields,
        },
    });
};

export const exportExcel = (params: H3.Export.Request.IExportExcelModel) =>
    request<H3.Http.Response.H3ResponseV2<H3.Export.Response.ExportExcelResponse>>('/ExcelExport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: JSON.stringify(params),
        },
    });

export const getExportProgress = (params: H3.Export.Request.IExportProgressModel) =>
    request<H3.Http.Response.H3ResponseV2<H3.Export.Response.GetExportProgressResponse>>('/ExcelExport/OnAction', {
        method: 'post',
        params,
    });

/**
 * 获取导入导出异步任务记录
 * @param params
 * @returns
 */
export const getTaskRecord = (params: H3.Export.Request.ITaskRecordModel) =>
    request<H3.Http.Response.H3ResponseV2<H3.Export.Response.TaskRecordResponse[]>>(
        '/h3/v1/importOrExport/getTaskRecord',
        {
            method: 'post',
            data: params,
        },
    );

/**
 * 取消等待中的导入导出异步任务
 * @param taskId 任务Id
 * @returns
 */
export const cancelWaitingTask = (taskId: string) =>
    request<H3.Http.Response.H3ResponseV2<H3.Export.Response.TaskRecordResponse[]>>(
        '/h3/v1/importOrExport/cancelWaitingTask',
        {
            method: 'get',
            params: {
                actionGuid: taskId,
            },
        },
    );

/** 根据异步任务id获取导出日志数据 */
export const getLogByTaskId = (taskId: string) =>
    request<H3.Http.Response.H3Response<H3.Export.Response.RecordDetailModel>>('/v1/bizlog/action/export/bytaskId', {
        method: H3.Http.MethodType.GET,
        params: { taskId },
    });

// 添加导出任务
export const addExportTask = (
    taskId: string,
    objectIds: string[],
    params: H3.Export.Request.IExportQueryBizDataRequest,
    exportImageFields: string[],
    splitAddressFields: string[],
    mergeRows: boolean,
    driveTicket?: string,
) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/dataExport/addExportTask', {
        method: H3.Http.MethodType.POST,
        data: {
            AsyncTaskId: taskId,
            ObjectIds: objectIds,
            QueryBizDataRequest: params,
            ExportImageFields: exportImageFields,
            SplitAddressFields: splitAddressFields,
            MergeRows: mergeRows,
            DriveTicket: driveTicket,
        },
    });
